import { Component, OnInit, inject } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { NavigationActions, ParentNavigationItem } from '@next/core-lib/navigation';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly store = inject<Store<RootState>>(Store);

  navigationItems: ParentNavigationItem[] = [];
  private readonly presalesOrderNavigationItem: ParentNavigationItem = {
    relativeUrl: '/',
    label: 'sidenav.presales-order',
    icon: 'dashboard',
  };
  private readonly fertilizerOrdersNavigationItem: ParentNavigationItem = {
    relativeUrl: '/fertilizerOrders',
    label: 'sidenav.fertilizer-order',
    icon: 'dashboard',
  };

  ngOnInit(): void {
    this.initializeNavigation();
  }

  private initializeNavigation(): void {
    this.store
      .select(UserSelectors.selectUserInitialized)
      .pipe(
        filter((userInitialized) => userInitialized),
        take(1),
      )
      .subscribe(() => {
        this.navigationItems = [this.presalesOrderNavigationItem, this.fertilizerOrdersNavigationItem];

        this.store.dispatch(NavigationActions.setNavigationItems({ navigationItems: this.navigationItems }));
      });
  }
}
